import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';

export const amsterdamOverspanningenBasisGegevensPaths = {
    '/api/surveys/{surveyId}/elements/{elementId}/inspectionStandardData/amsterdamOverspanningen/basisgegevens': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('elementId')],
        get: {
            operationId: 'aoBasisgegevensControllers.getElement',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Any(),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/basisgegevens': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('unitId')],
        get: {
            operationId: 'aoBasisgegevensControllers.getUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Any(),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'aoBasisgegevensControllers.updateUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Any(),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Any(),
                    },
                },
            },
        },
    },
} as const;
